'use client';

import React from 'react';

interface MenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const MenuButton: React.FC<MenuButtonProps> = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      aria-label={isOpen ? '메뉴 닫기' : '메뉴 열기'}
      className="flex justify-center items-center w-10 h-10 ml-1 cursor-pointer"
    >
      <div className={`relative w-6 h-[18px] transition-all duration-500 ease-in-out ${isOpen ? 'open' : ''}`}>
        <span
          className={`absolute left-0 h-0.5 w-full bg-[#B2B2B2] rounded-sm opacity-100 transition-all duration-250 ease-in-out 
            origin-left ${isOpen ? 'rotate-45 left-[3px]' : 'top-0 rotate-0'}`}
        />
        <span
          className={`absolute left-0 top-2 h-0.5 w-full bg-[#B2B2B2] rounded-sm transition-all duration-250 ease-in-out 
            origin-left ${isOpen ? 'w-0 opacity-0' : 'opacity-100'}`}
        />
        <span
          className={`absolute left-0 h-0.5 w-full bg-[#B2B2B2] rounded-sm opacity-100 transition-all duration-250 ease-in-out 
            origin-left ${isOpen ? 'rotate-[-45deg] top-[17px] left-[3px]' : 'top-4 rotate-0'}`}
        />
      </div>
    </button>
  );
};

export default MenuButton;
